<template>
  <section class="features" id="features">
    <div class="container">
      <h2 class="section-title centered fade-up fade-up-delay-1" v-html="titleHtml"></h2>
      <p class="section-desc centered fade-up fade-up-delay-2">
        {{ $t('features.desc') }}
      </p>
      <div class="features-grid">
        <div
          v-for="(item, i) in $tm('features.items')"
          :key="i"
          class="feature-card fade-up"
          :class="`fade-up-delay-${(i % 3) + 1}`"
          :style="i === 3 ? 'transition-delay:.35s' : ''"
        >
          <div class="feature-icon" :class="item.color">
            <!-- Kanban icon -->
            <svg v-if="item.icon === 'kanban'" viewBox="0 0 24 24">
              <rect x="3" y="3" width="7" height="18" rx="2"/>
              <rect x="14" y="3" width="7" height="11" rx="2"/>
              <rect x="14" y="18" width="7" height="3" rx="1"/>
            </svg>
            <!-- Clock icon -->
            <svg v-else-if="item.icon === 'clock'" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="9"/>
              <path d="M12 7v5l3.5 3.5" stroke-linecap="round"/>
            </svg>
            <!-- Chart icon -->
            <svg v-else-if="item.icon === 'chart'" viewBox="0 0 24 24">
              <path d="M3 18l4-8 4 4 4-6 4 10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- Calendar icon -->
            <svg v-else-if="item.icon === 'calendar'" viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="18" rx="3"/>
              <path d="M16 2v4M8 2v4M3 10h18" stroke-linecap="round"/>
              <circle cx="8" cy="16" r="1.5" fill="#8B5CF6" stroke="none"/>
              <circle cx="12" cy="16" r="1.5" fill="#8B5CF6" stroke="none"/>
            </svg>
            <!-- Earnings icon -->
            <svg v-else-if="item.icon === 'earnings'" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="9"/>
              <path d="M12 7v1.5M12 15.5V17" stroke-linecap="round"/>
              <path d="M9.5 14.5c0 1.1.9 2 2.5 2s2.5-.9 2.5-2-1-1.8-2.5-2-2.5-.9-2.5-2 .9-2 2.5-2 2.5.9 2.5 2" stroke-linecap="round"/>
            </svg>
            <!-- Collaboration icon -->
            <svg v-else-if="item.icon === 'collab'" viewBox="0 0 24 24">
              <circle cx="9" cy="7" r="3"/>
              <circle cx="17" cy="8" r="2.5"/>
              <path d="M3 19c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke-linecap="round"/>
              <path d="M17 13c2.2 0 4 1.8 4 4" stroke-linecap="round"/>
            </svg>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'FeaturesSection',
    computed: {
      titleHtml() {
        return this.$t('features.title').replace('\n', '<br/>')
      }
    }
  }
</script>

<style scoped>
.features { background: white; }

.features-grid {
  margin-top: 4rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
}

.feature-card {
  padding: 2rem;
  background: var(--bg);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  transition: transform var(--transition), box-shadow var(--transition), border-color var(--transition);
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
  border-color: rgba(91, 141, 184, 0.2);
}

.feature-icon {
  width: 52px; height: 52px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.feature-icon svg { width: 24px; height: 24px; fill: none; stroke-width: 1.8; }

.fi-blue { background: rgba(91, 141, 184, 0.12); stroke: var(--primary); }
.fi-blue svg { stroke: var(--primary); }
.fi-green { background: rgba(123, 175, 150, 0.12); }
.fi-green svg { stroke: var(--secondary); }
.fi-rose { background: rgba(232, 180, 160, 0.15); }
.fi-rose svg { stroke: var(--accent-dark); }
.fi-purple { background: rgba(167, 139, 250, 0.12); }
.fi-purple svg { stroke: #8B5CF6; }
.fi-amber { background: rgba(245, 158, 11, 0.10); }
.fi-amber svg { stroke: #D97706; }
.fi-teal { background: rgba(20, 184, 166, 0.10); }
.fi-teal svg { stroke: #0D9488; }

.feature-card h3 {
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 0.6rem;
  color: var(--text);
}

.feature-card p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.65;
}
</style>
